import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMoon, FiSun, FiCheck } from 'react-icons/fi';
import Header from './Header';
import '../styles/ThemeSettingsPage.css';

const ThemeSettingsPage = () => {
  const [selectedTheme, setSelectedTheme] = useState('dark');
  const [selectedAccent, setSelectedAccent] = useState('blue');

  const themes = [
    { id: 'dark', name: 'Dark Theme', icon: FiMoon },
    { id: 'light', name: 'Light Theme', icon: FiSun }
  ];

  const accentColors = [
    { id: 'blue', color: '#2B5AFF' },
    { id: 'purple', color: '#7B61FF' },
    { id: 'green', color: '#00C48C' },
    { id: 'orange', color: '#FF9F2D' },
    { id: 'pink', color: '#FF4B8C' }
  ];

  return (
    <div className="theme-page">
      <Header title="Theme Settings" />
      
      <div className="theme-content">
        <motion.div 
          className="theme-card"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <div className="theme-header">
            <div className="header-icon">
              <FiMoon />
            </div>
            <h2>Appearance</h2>
            <p>Customize how Telegram Wallet looks on your device</p>
          </div>

          <div className="theme-section">
            <h3>Theme</h3>
            <div className="theme-options">
              {themes.map(theme => (
                <motion.button
                  key={theme.id}
                  className={"theme-option " + (selectedTheme === theme.id ? 'selected' : '')}
                  onClick={() => setSelectedTheme(theme.id)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <div className="option-icon">
                    <theme.icon />
                  </div>
                  <span>{theme.name}</span>
                  {selectedTheme === theme.id && (
                    <div className="check-icon">
                      <FiCheck />
                    </div>
                  )}
                </motion.button>
              ))}
            </div>
          </div>

          <div className="accent-section">
            <h3>Accent Color</h3>
            <div className="accent-options">
              {accentColors.map(color => (
                <motion.button
                  key={color.id}
                  className={"accent-option " + (selectedAccent === color.id ? 'selected' : '')}
                  style={{ '--accent-color': color.color }}
                  onClick={() => setSelectedAccent(color.id)}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {selectedAccent === color.id && <FiCheck />}
                </motion.button>
              ))}
            </div>
          </div>

          <div className="theme-preview">
            <h3>Preview</h3>
            <div className={"preview-card " + selectedTheme}>
              <div className="preview-header"></div>
              <div className="preview-content">
                <div className="preview-item"></div>
                <div className="preview-item"></div>
                <div className="preview-button" style={{ background: accentColors.find(c => c.id === selectedAccent)?.color }}></div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ThemeSettingsPage; 